module.exports = __webpack_public_path__ + "media/images/emblems/La_Ferriere-coat_of_arms-71b3597e29ab6a089912438118cc6d62.svg";